export const USER_FEATURE_KEY = 'user';

export const USER_PERMISSION_ADMIN = 'CMI.App.Admin';
export const USER_PERMISSION_INTERNAL = 'CMI.App.Internal';
export const USER_PERMISSION_CLIENT = 'CMI.App.External';

export const USER_BUSY_INDICATOR = 'user-busy-indicator';
